
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startGranjaXID, startListadoGranjas } from "../../../services";






export const useGranjaXID = (id) => {

    const granjaXIDQuery = useQuery({
        queryKey: ['granja-id', id], 
        queryFn: () => startGranjaXID(id),
    });

    return {
        granjaXIDQuery
    }
}





export const useGranjasQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const granjasListQuery = useQuery({
        queryKey: ['granjas-list', { page, termino }], 
        queryFn: () => startListadoGranjas({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        granjasListQuery,
    }
}
